<template>
  <!-- [Added by E2logy]: number of survey photos and ratings still saved on the
  device. It reads the shared state of the photo queue, so it updates by itself
  every time a photo is saved or sent, and hides when nothing is left. -->
  <component
    :is="isLink ? 'router-link' : 'div'"
    v-if="pendingCount > 0"
    :to="isLink ? { name: 'router_pending_photos' } : null"
    class="d-block pending_photos_count"
  >
    <b-icon
      :icon="failedCount > 0 ? 'exclamation-triangle-fill' : 'cloud-arrow-up'"
      :variant="failedCount > 0 ? 'danger' : 'warning'"
    ></b-icon>
    {{ $t("pending_photos_count_label") }}:
    <b>{{ pendingCount }}</b>
    <span v-if="failedCount > 0" class="text-danger">
      ({{ failedCount }} {{ $t("pending_photos_with_error") }})
    </span>
  </component>
</template>

<script>
import PhotoQueueService from "@/services/photoQueueService";

export default {
  name: "PendingPhotosCount",
  props: {
    // Link to the pending photos page. Off on that page itself.
    isLink: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    // Photos plus ratings, the same total the finish route check uses.
    pendingCount() {
      return (
        PhotoQueueService.state.pendingCount +
        PhotoQueueService.state.pendingPortalCount
      );
    },
    failedCount() {
      return PhotoQueueService.state.failedCount;
    }
  }
};
</script>
